export function mapFrequency(frequency: string | null | undefined) {
  switch (frequency) {
    case 'every_hour':
      return 'hourly';
    case 'every_day':
      return 'daily';
    default:
      return frequency;
  }
}
